// extracted by mini-css-extract-plugin
export default {"chatBubbleContainer":"ChatBubble_chatBubbleContainer__9+Qrh","adminName":"ChatBubble_adminName__NOGjh","chatBubble":"ChatBubble_chatBubble__h7ETx"};